import React, {useState, useEffect} from 'react'
import ProgressIndicator from '../Indicator/ProgressIndicator';
import { lightBlue } from '@mui/material/colors';
import BottomPadding from '../BottomPadding/bottompadding';

const ProgramCOmmentsList = (id) => {

const [isloading, setLoading] = useState(false);
const [commentslist, setCommentsList] = useState();

const getProgramcommentlist = async (pi) => {
//    console.log(id);
    const API_URL = `https://www.sasyavatagro.com/repos/api/dairyfarm/getprogramcomments/${pi}`;
    try{
        const response = await fetch(API_URL);
        if (!response.status) throw Error("Failed to fetch data");
        let valuelist = await response.json();
//        console.log(valuelist);      
        setCommentsList(valuelist);
        setLoading(true);
    } catch (err) {
        console.log(err);
    }

}

    useEffect(()=>{
        if (!isloading) {
         getProgramcommentlist(id.id);   
         window.scrollTo(0, 0);
        }        
    }, [isloading]);

    return (
        <>

        {!isloading && <ProgressIndicator />}
        {isloading && 
        <div>
            <div style={{textAlign:'left', paddingLeft:'20px', backgroundColor:'lightskyblue', margin:'10px', height:'30px', lineHeight:'2.0'}}>
               <b> Program Comments</b>
            </div>
        {
            commentslist.map((item)=>(                
                <div key={item.commentid} style={{textAlign:'left', padding:'10px'}}>
                    <span><b> {item.CreateDate.substring(0,10)} </b> <br/><br/></span>
                   <span> {item.Comment} </span></div>
            ))
        }

        </div>}
           {/* <div style={{position:'relative', bottom:'0px',  height:'120px', width:'100vw', backgroundColor:'#F2EBEB'}}></div>  */}
<BottomPadding pad={'120px'} />
        </>
    );
}

export default ProgramCOmmentsList